import { API_BASE } from "../apiConfig";

function isLocalDevBrowser() {
  if (typeof window === "undefined") return false;
  return ["localhost", "127.0.0.1"].includes(window.location.hostname);
}

async function readErrorMessage(res) {
  const text = await res.text();
  let payload = {};
  if (text) {
    try {
      payload = JSON.parse(text);
    } catch {
      /* body is HTML or plain text */
    }
  }
  if (payload.error) return String(payload.error);
  const snippet = text && text.length < 500 ? text.replace(/\s+/g, " ").trim().slice(0, 240) : "";
  if (snippet && !snippet.startsWith("<")) return `${snippet} (HTTP ${res.status})`;
  if (res.status === 404) {
    return isLocalDevBrowser()
      ? `API לא נמצא (HTTP 404). ודאו שהבקאנד רץ (למשל פורט 4000) והפרוקסי ב־package.json תואם.`
      : `Not found (HTTP 404)`;
  }
  return `HTTP ${res.status}${snippet ? `: ${snippet.slice(0, 80)}` : ""}`;
}

async function request(path, options = {}) {
  const headers = { "Content-Type": "application/json", ...(options.headers || {}) };
  let res;
  try {
    res = await fetch(`${API_BASE}/api/auth${path}`, {
      ...options,
      headers,
      credentials: "include",
    });
  } catch (e) {
    const msg = String(e?.message || e || "Network error");
    const hint = isLocalDevBrowser()
      ? " — בדקו שהשרת רץ (backend) ושהפרוקסי ב־frontend מצביע על הפורט הנכון (ברירת מחדל 4000)."
      : "";
    throw new Error(msg + hint);
  }
  if (!res.ok) {
    const message = await readErrorMessage(res);
    throw new Error(message);
  }
  return res.json();
}

async function requestIdentity(path, options = {}) {
  const headers = { "Content-Type": "application/json", ...(options.headers || {}) };
  let res;
  try {
    res = await fetch(`${API_BASE}/api/identity${path}`, {
      ...options,
      headers,
      credentials: "include",
    });
  } catch (e) {
    const msg = String(e?.message || e || "Network error");
    const hint = isLocalDevBrowser()
      ? " — בדקו שהשרת רץ (backend) ושהפרוקסי ב־frontend מצביע על הפורט הנכון (ברירת מחדל 4000)."
      : "";
    throw new Error(msg + hint);
  }
  if (!res.ok) {
    const message = await readErrorMessage(res);
    throw new Error(message);
  }
  return res.json();
}

export function registerUser(payload) {
  return request("/register", { method: "POST", body: JSON.stringify(payload) });
}

export function loginUser(payload) {
  return request("/login", { method: "POST", body: JSON.stringify(payload) });
}

export function logoutUser() {
  return request("/logout", { method: "POST" });
}

export function fetchUserMe() {
  return request("/me");
}

export function requestRecoveryCode(payload) {
  return request("/recover/request", { method: "POST", body: JSON.stringify(payload) });
}

export function verifyRecoveryCode(payload) {
  return request("/recover/verify", { method: "POST", body: JSON.stringify(payload) });
}

export function resetRecoveryPassword(payload) {
  return request("/recover/reset", { method: "POST", body: JSON.stringify(payload) });
}

export function startSoftIdentity(payload) {
  return requestIdentity("/start", { method: "POST", body: JSON.stringify(payload) });
}

export function linkRecoveryEmail(payload) {
  return request("/link-email", { method: "POST", body: JSON.stringify(payload) });
}

export function updateUserProfile(payload) {
  return request("/profile", { method: "POST", body: JSON.stringify(payload) });
}
